var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 23.808C50.1084 23.808 53.2332 26.2632 53.2332 31.3596C53.2332 36.456 50.1084 41.5152 46.5 41.5152C42.8916 41.5152 39.7668 36.456 39.7668 31.3968C39.7668 26.3376 42.8916 23.808 46.5 23.808Z",
    fill: "#750AAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 46.7232C49.848 46.7232 49.9224 42.8916 51.2244 43.152C52.5264 43.4124 53.3449 43.8216 54.5352 44.3052C57.7717 45.6444 60.5244 46.9836 60.5244 50.5548V53.9028C49.0296 59.0364 42.222 58.032 32.4012 53.9028V50.5548C32.4012 46.8348 35.4516 45.5328 38.3904 44.3052C39.5808 43.8216 40.362 43.4124 41.7012 43.152C43.0776 42.8916 43.5612 46.7232 46.5 46.7232Z",
    fill: "#750AAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9688 7.55162C68.9688 3.90602 65.9928 0.967224 62.3844 0.967224H30.5784C26.9328 0.967224 23.994 3.94322 23.994 7.55162V85.4484C23.994 89.094 26.97 92.0328 30.5784 92.0328H62.3472C65.9928 92.0328 68.9316 89.0568 68.9316 85.4484L68.9688 7.55162ZM63.5376 85.4484C63.5376 86.0808 63.0168 86.6016 62.3844 86.6016H30.5784C29.946 86.6016 29.4252 86.0808 29.4252 85.4484V7.55162C29.4252 6.91922 29.946 6.39842 30.5784 6.39842H62.3472C62.9796 6.39842 63.5004 6.91922 63.5004 7.55162L63.5376 85.4484ZM40.734 2.30642H52.266C53.01 2.30642 53.6424 2.90162 53.6424 3.68282C53.6424 4.42682 53.0472 5.05922 52.266 5.05922H40.734C39.99 5.05922 39.3576 4.46402 39.3576 3.68282C39.3576 2.90162 39.99 2.30642 40.734 2.30642Z",
    fill: "#750AAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.b298a52f302db64e77eb28b8c7586bfc.svg";
export { ForwardRef as ReactComponent };